import { atom } from "recoil";

const cambiosNoGuardadosState = atom({
    key: "cambiosNoGuardadosState", // unique ID (with respect to other atoms/selectors)
    default: false // default value (aka initial value)
  });
  export default cambiosNoGuardadosState;
  